import { trackCopyExperimentExposure } from '../store/experiments/action-creators';
import { ExperimentActionTypes } from '../store/experiments/action-types';
import { getHasExposureBeenTracked, getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { FlowActionTypes } from '../store/flow/action-types';
import { ExperimentKeys } from './ExperimentKeys';
import { ExperimentParameterGroup } from './ExperimentParameterGroup';
import { getActiveCopyExperimentIds } from './copyExperimentUtils';
import { changeHublessThemeSetting } from 'foundations-theming/utils/themeSwitcher';
export function safeGetLocalStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error);
    return null;
  }
}
export function safeSetLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error);
  }
}
export const ExperimentsTrackingMiddleware = store => next => action => {
  const state = store.getState();
  if (action.type === FlowActionTypes.Load || action.type === FlowActionTypes.StepCompleted || action.type === ExperimentActionTypes.ExperimentsFetched) {
    const copyExperimentKeys = getActiveCopyExperimentIds(state);
    copyExperimentKeys.forEach(id => {
      if (!getHasExposureBeenTracked(state, id)) {
        store.dispatch(trackCopyExperimentExposure(id));
      }
    });
    const isAssignedToACQ176VariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0176, [ExperimentParameterGroup.Variant_A]);
    if (action.type === ExperimentActionTypes.ExperimentsFetched) {
      if (isAssignedToACQ176VariantA) {
        const isTrellisThemeEnabled = safeGetLocalStorage('hubspot-theme:hubless') === 'trellis-light';
        const hasReloaded = safeGetLocalStorage('trellis:reloaded') === 'true';
        if (!isTrellisThemeEnabled && !hasReloaded) {
          changeHublessThemeSetting('trellis', 'light');
          try {
            safeSetLocalStorage('trellis:reloaded', 'true');
            const persisted = safeGetLocalStorage('trellis:reloaded');
            if (persisted) {
              window.location.reload();
              return;
            }
          } catch (e) {
            // localStorage unavailable (private mode/blocked). Skip reload to avoid loops.
          }
        }
      }
    }
  }
  return next(action);
};